import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { listPublished } from "../utils/api";

export default function HomePage() {
  const [storefronts, setStorefronts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    listPublished()
      .then(setStorefronts)
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <div className="loading-block container">
      <span className="spinner spinner-dark" /> Loading storefronts…
    </div>
  );

  if (error) return (
    <div className="container" style={{padding:"40px 0",color:"var(--danger)"}}>⚠ {error}</div>
  );

  return (
    <div className="container main-area">
      <div style={{padding:"48px 0 32px"}}>
        <h1 className="sf-title">Curated Amazon UK Picks</h1>
        <p className="sf-desc">
          Hand-curated collections of the best baby and parenting products on Amazon UK.
          Every product is fetched live from Amazon with real ratings and prices.
        </p>
      </div>

      {storefronts.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">🏪</div>
          <p>No published storefronts yet.</p>
          <p style={{marginTop:8,fontSize:".85rem"}}>
            <Link to="/admin" style={{color:"var(--forest)",fontWeight:600}}>Go to Admin</Link> to create your first one.
          </p>
        </div>
      ) : (
        <div style={{
          display:"grid",
          gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))",
          gap:20, paddingBottom:40,
        }}>
          {storefronts.map(sf => (
            <Link key={sf.id} to={`/s/${sf.slug}`} style={{display:"block"}}>
              <div className="card card-padded" style={{height:"100%",transition:"all .2s",cursor:"pointer"}}
                onMouseEnter={e => e.currentTarget.style.boxShadow="var(--shadow-md)"}
                onMouseLeave={e => e.currentTarget.style.boxShadow=""}>
                <p style={{fontSize:".72rem",fontWeight:600,textTransform:"uppercase",
                           letterSpacing:".1em",color:"var(--muted)",marginBottom:8}}>
                  {sf.category || "Curated Collection"}
                </p>
                <h2 style={{fontFamily:"var(--ff-d)",fontSize:"1.15rem",lineHeight:1.3,marginBottom:8}}>
                  {sf.title}
                </h2>
                {sf.seo_desc && (
                  <p style={{fontSize:".83rem",color:"var(--muted)",lineHeight:1.55}}>
                    {sf.seo_desc.slice(0,110)}{sf.seo_desc.length>110?"…":""}
                  </p>
                )}
                <p style={{marginTop:14,fontSize:".8rem",color:"var(--forest)",fontWeight:600}}>
                  Browse collection →
                </p>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
